import React from 'react';
import { Box, Stack } from '@mui/material';

export function ErrorMessage({ children }: { children: React.ReactNode }): JSX.Element {
  return (
    <Box sx={{ margin: 'auto', width: 500 }}>
      <Box
        component='img'
        sx={{ width: '100%', mt: 8, mb: 5 }}
        src='https://homesusastorage.blob.core.windows.net/webimages/SpecDeck-Blue-Logo-medium.png'
      />
      <Stack sx={{ width: '80%', margin: 'auto' }} spacing={2}>
        {children}
      </Stack>
    </Box>
  );
}
